import { DEFAULT_SPOTLIGHT_SHORTCUT } from '../constants';

function normalizeShortcut(shortcut: string): string {
  return shortcut.toLowerCase().replace(/\s+/g, '');
}

function matchesShortcut(event: KeyboardEvent, shortcut: string): boolean {
  const parts = normalizeShortcut(shortcut).split('+');
  const needsMod = parts.includes('mod');
  const needsShift = parts.includes('shift');
  const needsAlt = parts.includes('alt');
  const key = parts.find((part) => !['mod', 'shift', 'alt', 'ctrl', 'meta'].includes(part)) ?? 'f';

  const modPressed = event.metaKey || event.ctrlKey;
  if (needsMod && !modPressed) return false;
  if (needsShift && !event.shiftKey) return false;
  if (needsAlt && !event.altKey) return false;

  return event.key.toLowerCase() === key.toLowerCase();
}

export type ShortcutController = {
  destroy: () => void;
};

export function bindSpotlightShortcut(
  onTrigger: () => void,
  shortcut = DEFAULT_SPOTLIGHT_SHORTCUT,
): ShortcutController {
  const handler = (event: KeyboardEvent) => {
    if (matchesShortcut(event, shortcut)) {
      event.preventDefault();
      onTrigger();
    }
  };

  window.addEventListener('keydown', handler);
  return {
    destroy: () => window.removeEventListener('keydown', handler),
  };
}
